import { useWeb3React } from '@web3-react/core';
export var useDomainName = function useDomainName() {
  var _useWeb3React = useWeb3React(),
      ENSName = _useWeb3React.ENSName;

  return {
    name: ENSName || ''
  };
};